import React, { Component } from "react"
import PropTypes from "prop-types"

export default class Description extends Component {
  render() {
    return (
      <div className="connection-description">
        <span>{this.props.text}</span>
      </div>
    )
  }
}

Description.propTypes = {
  text: PropTypes.string.isRequired,
}
